<app-page-title [title]="'Activate Account'"></app-page-title>
<div class="row">
    <div class="col-md-12">
        <p>Please wait, Activating..</p>
    </div>
    <app-modal
        #activationModal
        title="Account Activation Status"
        body=""
    >
    </app-modal>
</div>
